<!--
  @author:gll
  @time:2019/8/8
  @disc:商品权限->配置权限弹窗
 -->

<template>
  <el-dialog
    title="配置权限"
    :visible.sync="visible"
    width="500px"
    @close="handleClose">
    <div class="config-wrap">
      <div class="customer-name" v-if="selectedList.length > 0">{{info.customerName}}已有的商品权限：</div>
      <div class="customer-name" v-else>{{info.customerName}}暂无商品权限，请先新增！</div>
      <div class="container-tag" v-if="selectedList.length > 0">
        <el-tag
          v-for="item in selectedList"
          :key="item.id"
          closable
          @close="handleRemove(item.id)">
          {{item.name}}
        </el-tag>
      </div>
      <div class="tip"><span>*</span> 新增时可在下方输入框搜索添加商品，也可直接选择添加</div>
      <div class="search-chemical">
        <search-select
          v-model="selected"
          placeholder="请输入商品名称"
          type="chemical"
          clearable
          ref="select"></search-select>
        <el-button
          @click="handleAdd"
          icon="el-icon-plus"
          :disabled="!selected"
          class="btn-add"></el-button>
      </div>
      <div class="chemical-tree">
        <el-tree
          class="industry-tree"
          v-loading="loading"
          node-key="id"
          show-checkbox
          :props="{ value: 'id', label: 'categoryName', children: 'levelDtos', disabled: 'disabled' }"
          :data="region"
          ref="tree"
          :default-checked-keys="defaultCheckedData"
          @check-change="handleCheck">
        </el-tree>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取 消</el-button>
      <el-button type="primary" @click="handleSubmit">保存</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapActions } from 'vuex'
import SearchSelect from '../../../../components/searchSelect/index'
export default {
  name: 'configDialog',
  components: { SearchSelect },
  props: ['show', 'info'],
  data () {
    return {
      loading: false,
      visible: this.show,
      selected: '',
      selectedList: [],
      propsFormat: { value: 'id', label: 'categoryName', children: 'children', disabled: 'disabled' },
      checkedData: [],
      region: []
    }
  },
  computed: {
    defaultCheckedData () {
      return this.selectedList.map(item => item.id)
    }
  },
  methods: {
    ...mapActions(['addChemicalPermission', 'allChemicalCategory']),
    handleRemove (id) {
      this.selectedList.forEach((val, index) => {
        if (val.id === id) {
          this.selectedList.splice(index, 1)
        }
      })
    },
    handleAdd () {
      const isExist = this.$lodash.find(this.selectedList, { id: this.selected.id })
      if (isExist) {
        this.$message.error('请勿添加重复商品！')
        this.selected = ''
      } else {
        this.selectedList.push(this.selected)
      }
    },
    handleCheck (val, checked) {
      const arr = this.$refs.tree.getCheckedNodes(true)
      const arrPro = arr.filter(item => {
        return item.level === 4
      })
      this.selectedList = arrPro.map(item => {
        return {
          id: item.id,
          name: item.categoryName
        }
      })
    },
    async handleSubmit () {
      let params = {
        status: 1,
        accountId: [this.info.accountId],
        itemId: this.selectedList.map(item => item.id)
      }
      let res = await this.addChemicalPermission(params)
      if (res.success) {
        this.visible = false
        this.$message.success('权限配置成功！')
      }
    },
    handleClose () {
      this.$emit('update:show', false)
      this.selectedList = []
    }
  },
  watch: {
    show () {
      this.visible = this.show
      this.selectedList = this.info.permissionList.map(item => {
        return {
          id: item.itemId,
          name: item.itemName
        }
      })
      if (this.visible) {
        this.loading = true
        this.allChemicalCategory().then(res => {
          this.region = res
          this.region.forEach(item => {
            if (item.levelDtos) {
              item.levelDtos.forEach(item2 => {
                if (item2.levelDtos) {
                  item2.levelDtos.forEach(item3 => {
                    if (item3.itemIdNameDtos && item3.itemIdNameDtos.length > 0) {
                      item3.levelDtos = item3.itemIdNameDtos.map(item4 => {
                        return {
                          categoryName: item4.itemName,
                          level: 4,
                          id: item4.itemId
                        }
                      })
                    }
                  })
                }
              })
            }
            this.loading = false
          })
        })
      }
    },
    selectedList (newVal) {
      this.selected = ''
      this.$nextTick(() => {
        this.$refs.select.dataArr = []
        this.$refs.tree.setCheckedKeys(newVal.map(item => item.id))
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.config-wrap{
  margin-top: -15px;
}
.customer-name{
  margin-bottom: 15px;
}
.container-tag {
.el-tag {
  margin-right: 15px;
  margin-bottom: 15px;
}
}
.tip{
  margin-bottom: 15px;
  span{
    color: red;
  }
}
.search-chemical{
  .el-button{
    margin-left: 10px;
  }
}
.chemical-tree{
  margin-top: 10px;
  max-height: 240px;
  overflow-y: auto;
}
</style>
